import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";
import { LogoHorizontal } from "@/components/Logo";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ username: "", password: "", nickname: "", phone: "", avatar_url: "" });
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await register(form);
      toast.success(`Chào ${u.nickname}, bắt đầu hành trình rank!`);
      nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Đăng ký thất bại");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen relative overflow-hidden bg-[#05050a]">
      <div className="absolute inset-0 bg-grid opacity-40" />
      <div className="absolute -top-40 -right-40 w-[480px] h-[480px] rounded-full bg-cyan-500/10 blur-3xl" />
      <div className="absolute -bottom-40 -left-40 w-[480px] h-[480px] rounded-full bg-purple-500/10 blur-3xl" />

      <div className="relative max-w-md mx-auto px-6 py-14">
        <LogoHorizontal size={56} className="mb-8" />

        <h1 className="font-display text-3xl font-bold mb-2">Đăng ký</h1>
        <p className="text-white/50 text-sm mb-8">Tạo nhân vật. Bắt đầu từ Bạc · 1000 ELO.</p>

        <form onSubmit={submit} className="space-y-4">
          {[
            { k: "username", label: "Tên đăng nhập", placeholder: "vd: minh_pro", required: true },
            { k: "password", label: "Mật khẩu", placeholder: "••••••", type: "password", required: true },
            { k: "nickname", label: "Nickname trong game", placeholder: "vd: Minh Rồng", required: true },
            { k: "phone", label: "Số điện thoại", placeholder: "Tùy chọn" },
            { k: "avatar_url", label: "Link avatar", placeholder: "https://... (tùy chọn)" },
          ].map((f) => (
            <div key={f.k}>
              <label className="text-xs uppercase tracking-wider text-white/60 mb-1.5 block">{f.label}</label>
              <input
                data-testid={`register-${f.k}`}
                type={f.type || "text"}
                value={form[f.k]}
                onChange={set(f.k)}
                required={f.required}
                placeholder={f.placeholder}
                className="w-full bg-white/[0.03] border border-white/10 focus:border-cyan-400/60 outline-none rounded-md px-4 py-3 text-sm transition"
              />
            </div>
          ))}

          <button
            data-testid="register-submit"
            disabled={busy}
            className="w-full mt-2 py-3 rounded-md font-display font-semibold uppercase tracking-wider text-sm bg-gradient-to-r from-cyan-400 to-purple-500 text-black hover:opacity-90 disabled:opacity-50 transition flex items-center justify-center gap-2"
          >
            {busy && <Loader2 size={16} className="animate-spin" />} Tạo tài khoản
          </button>
        </form>

        <div className="mt-6 text-center text-sm text-white/50">
          Đã có tài khoản? <Link to="/login" className="text-cyan-300 hover:underline" data-testid="goto-login">Đăng nhập</Link>
        </div>
      </div>
    </div>
  );
}
